import { NgModule } from '@angular/core';
import { HeaderNavComponent } from './header-nav/header-nav.component';
import { AsideNavComponent } from './aside-nav/aside-nav.component';
import { FooterComponent } from './footer/footer.component';
import { ScrollTopComponent } from './scroll-top/scroll-top.component';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule } from '@angular/forms';
import { QuickSidebarComponent } from './quick-sidebar/quick-sidebar.component';
import { SearchBarModule } from './search-bar/search-bar.module';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { LayoutComponent } from './layout/layout.component';
import { AsideLeftMinimizeDefaultEnabledComponent } from '../pages/aside-left-minimize-default-enabled/aside-left-minimize-default-enabled.component';
import { DefaultComponent } from '../pages/default/default.component';
import { HrefPreventDefaultDirective } from '@global-directives/href-prevent-default.directive';
import { UnwrapTagDirective } from '@global-directives/unwrap-tag.directive';
import {  PopoverModule } from 'ngx-bootstrap/popover';
import { PreviewThemeComponent } from '@theme/pages/default/preview/preview-theme.component';
import { ParameterService } from 'app/vbt-ticari/common/_services/Parameter.service';


@NgModule({
  declarations: [
    LayoutComponent,
    AsideLeftMinimizeDefaultEnabledComponent,
    HeaderNavComponent,
    DefaultComponent,
    PreviewThemeComponent,
    AsideNavComponent,
    FooterComponent,
    ScrollTopComponent,
    HrefPreventDefaultDirective,
    UnwrapTagDirective,
    QuickSidebarComponent
  ],
  imports: [
    BsDatepickerModule,
    CommonModule,
    FormsModule,
    HttpClientModule,
    CommonModule,
    RouterModule,
    NgSelectModule,
    PopoverModule,
    SearchBarModule
  ],
  exports: [
    BsDatepickerModule,
    LayoutComponent,
    AsideLeftMinimizeDefaultEnabledComponent,
    HeaderNavComponent,
    DefaultComponent,
    PreviewThemeComponent,
    AsideNavComponent,
    FooterComponent,
    ScrollTopComponent,
    HrefPreventDefaultDirective,
    NgSelectModule,
    QuickSidebarComponent
  ],
  providers: [
    ParameterService
  ]
})
export class LayoutModule {
  constructor() {
  }
}
